import React from 'react';

import styled from 'styled-components';

import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { SpinnerCircle } from 'apps/auth/components/common/SpinnerCircle/SpinnerCircle';
import { useApp } from 'apps/auth/hooks/selectors';
import media from 'apps/auth/theme/media';

const SpinnerContainer = styled.div`
    margin-left: -50%;
    display: flex;
    align-items: center;

    ${media.tablet720} {
        margin-left: 0;
    }
`;

const HistorySpinner = ({ forceShow = false }) => {
    const { isShowCustomSpinner } = useApp();

    if (isShowCustomSpinner || forceShow) {
        return (
            <FixedBottomPanel forSpinner>
                <SpinnerContainer>
                    <SpinnerCircle size="32px" />
                </SpinnerContainer>
            </FixedBottomPanel>
        );
    } else {
        return false;
    }
};

export default HistorySpinner;
